import { SwiperOptions } from 'swiper';
import { environment } from '../../../environments/environment';
/*These are the available methods for deposit. These methods are checked and intersection with the incoming methods
from backend and then displayed in the frontend. The availablePaymentMethodsMap maps methods to translations*/
export const availablePaymentMethods = ['CREDITCARD', 'PAYPAL', 'NETELLER', 'SKRILL', "TRUSTLY", "ZIMPLER", "VISA_HOSTED", "RAPID_TRANSFER", "SOFORT","IDEAL"];
export const availablePaymentMethodsMap = {
  'CREDITCARD': [ { 'methodName': 'VISA', 'dispalyName': 'paymentOptions.visa','description': 'paymentOptionsDescription.visa', "icon" : 'visa' },
  { 'methodName': 'MASTERCARD', 'dispalyName': 'paymentOptions.mastercard','description': 'paymentOptionsDescription.mastercard', "icon" : 'master' }],
  'PAYPAL': [{ 'methodName': 'PAYPAL', 'dispalyName': 'paymentOptions.paypal','description': 'paymentOptionsDescription.paypal',"icon" : 'paypal' }],
  'NETELLER': [{ 'methodName': 'NETELLER', 'dispalyName': 'paymentOptions.neteller','description': 'paymentOptionsDescription.neteller', "icon" : 'neteller' }],
  'SKRILL': [{ 'methodName': 'SKRILL', 'dispalyName': 'paymentOptions.skrill', 'description': 'paymentOptionsDescription.skrill' ,"icon" : 'skrill'}],
  'TRUSTLY': [{ 'methodName': 'TRUSTLY', 'dispalyName': 'paymentOptions.trustly','description': 'paymentOptionsDescription.trustly',"icon" : 'trustly' }],
  'ZIMPLER': [{ 'methodName': 'ZIMPLER', 'dispalyName': 'paymentOptions.zimpler','description': 'paymentOptionsDescription.zimpler', "icon" : 'zimpler' }],
  'VISA_HOSTED': [{ 'methodName': 'VISA_HOSTED', 'dispalyName': 'paymentOptions.visaHosted','description': 'paymentOptionsDescription.visaHosted', "icon" : 'visahosted' }],
  'RAPID_TRANSFER': [{ 'methodName': 'RAPID_TRANSFER', 'dispalyName': 'paymentOptions.rapidTransfer', 'description': 'paymentOptionsDescription.rapidTransfer',"icon" : 'rapidtransfer' }],
  'IDEAL': [{ 'methodName': 'IDEAL', 'dispalyName': 'paymentOptions.ideal','description': 'paymentOptionsDescription.ideal',"icon" : 'ideal' }],
  'SOFORT': [{ 'methodName': 'SOFORT', 'dispalyName': 'paymentOptions.sofort','description': 'paymentOptionsDescription.sofort',"icon" : 'sofort' }]
};

export const availableWithdrawMethods = ["CREDITCARD", "NETELLER", "WIRE_TRANSFER", "TRUSTLY","SKRILL","RAPID_TRANSFER"];
export const availableWithdrawMethodsMap = {
  "CREDITCARD": [{ "methodName": "VISA", "dispalyName": "paymentOptions.visa" },
  { "methodName": "MASTERCARD", "dispalyName": "paymentOptions.mastercard" }],
  "NETELLER": [{ "methodName": "NETELLER", "dispalyName": "paymentOptions.neteller" }],
  "WIRE_TRANSFER": [{ "methodName": "WIRE_TRANSFER", "dispalyName": "paymentOptions.bankTransfer" }],
  "TRUSTLY": [{ "methodName": "TRUSTLY", "dispalyName": "paymentOptions.trustly" }],
  'SKRILL': [{ 'methodName': 'SKRILL', 'dispalyName': 'paymentOptions.skrill' }],
  'RAPID_TRANSFER': [{ 'methodName': 'RAPID_TRANSFER', 'dispalyName': 'paymentOptions.rapidTransfer' }],
  'IDEAL': [{ 'methodName': 'IDEAL', 'dispalyName': 'paymentOptions.ideal' }],
  'SOFORT': [{ 'methodName': 'SOFORT', 'dispalyName': 'paymentOptions.sofort' }]
};
export const transactionTypeConfs = [{ key: "ALL", value: "transactionComp.all" },
{ key: "REAL_CASH_DEPOSIT", value: "transactionComp.deposits" },
{ key: "REAL_CASH_WITHDRAW", value: "transactionComp.withdrawals" },
{ key: "REAL_CASH_CASHOUT_REVERSAL", value: "transactionComp.cancelledWithdrawals" },
{ key: "POSITIVE", value: "transactionComp.positiveBalanceAdjustment" },
{ key: "NEGATIVE", value: "transactionComp.negativeBalanceAdjustment" },
];

export const transactionTypeForALL = ["REAL_CASH_DEPOSIT",
  "REAL_CASH_WITHDRAW",
  "PLAYER_SUBSCRIPTION",
  "REAL_CASH_ADDITION_BY_CS",
  "REAL_CASH_REMOVAL_BY_CS",
  "NEGATIVE_BALANCE_ADDITION_FOR_WIN_REVERSE",
  "REAL_CASH_ADJUSTMENT_FOR_WIN_REVERSE_CAPTURE",
  "POSITIVE_ADJUSTMENT",
  "NEGATIVE_ADJUSTMENT",
  "NEGATIVE_BALANCE_ADDITION_FOR_FRAUD",
  "REAL_CASH_ADJUSTMENT_FOR_FRAUD_CAPTURE_BY_CS",
  "REAL_CASH_CASHOUT_REVERSAL"];

export const NegativeTxns = [
  "REAL_CASH_REMOVAL_BY_CS",
  "NEGATIVE_BALANCE_ADDITION_FOR_WIN_REVERSE",
  "REAL_CASH_ADJUSTMENT_FOR_WIN_REVERSE_CAPTURE",
  "NEGATIVE_ADJUSTMENT",
  "NEGATIVE_BALANCE_ADDITION_FOR_FRAUD",
  "REAL_CASH_ADJUSTMENT_FOR_FRAUD_CAPTURE_BY_CS"
];

export const PostiveTxns = [
  "REAL_CASH_ADDITION_BY_CS",
  "POSITIVE_ADJUSTMENT"];
export const dateMobiScroll = {
  theme: 'ios',
  display: 'bottom',
  width: 200
}

export const selfExclusionList = [

  { days: 180, period: 'accountstatusComp.accountstatus27' },
  { days: 270, period: 'accountstatusComp.accountstatus28' },
  { days: 1 * 365, period: 'accountstatusComp.accountstatus29' },
  { days: 2 * 365, period: 'accountstatusComp.accountstatus30' },
  { days: 5 * 365, period: 'accountstatusComp.accountstatus31' },
  { days: 5256000, period: 'accountstatusComp.accountstatus32' }
];


export const coolOff = [
  { days: 1, period: 'accountstatusComp.accountstatus22' },
  { days: 3, period: 'accountstatusComp.accountstatus23' },
  { days: 7, period: 'accountstatusComp.accountstatus24' },
  { days: 30, period: 'accountstatusComp.accountstatus25' },
  { days: 90, period: 'accountstatusComp.accountstatus26' }
];

export const gameCategoryMap: Map<string, string> = new Map<string, string>();
gameCategoryMap.set("new", "gamingComp.gaming10");
gameCategoryMap.set("video_slots", "gamingComp.gaming11");
gameCategoryMap.set("video_poker", "gamingComp.gaming13");
gameCategoryMap.set("table_games", "gamingComp.gaming14");
gameCategoryMap.set("live_casino", "gamingComp.gaming15");
gameCategoryMap.set("allgames", "gamingComp.gaming16");

export const maplocation = [
  // '/login',
  '/register',
  '/forgotpassword',
  '/otp',
  '/deposit',
  '/withdraw',
  '/success',
  '/failure',
  '/txn-confirmation',
  '/reset-password',
  '/withdraw/cancelWithdrawal',
  '/withdraw/confirmCancelWithdraw',
  '/accountstatus',
  '/setlimits',
  '/myaccount/preferencecenter',
  '/sms',
  '/playnow',
  '/maintainance',
  '/trustly-login',
  '/payandplay',
  '/mob_register'
]

export const mapNotifylocation = [
  '/allgames',
  '/promotions',
  '/gameplay',
  '/casino'
]


export const mapMobFooterRibbonlocation = [
  '/allgames',
  '/categoryallgames',
  '/casino'
]


export const mapSearchNonStickylocation = [
  '/allgames',
  '/categoryallgames',
  '/casino'
]

export const loggedOffAccessLinks = [
  '/register',
  '/login',
  '/allgames',
  '/forgotpassword',
  '/reset-password',
  '/page',
  '/promotionsContent',
  '/contact',
  'toSetLimit',
  'bonusCode',
  'gameplay',
  '/promotions',
  '/casino'
]

export const countryUserCurrencies:any = [

  {
    countries: ["AL","AD", "AM", "AT", "BY", "BE", "BA", "BG", "HR", "CY", "CZ", "EE", "FO", "FI", "FR", "GE", "DE","GB", "GI", "GR", "IS", "IE", "IM", "IT", "XK", "LV", "LI", "LT", "LU", "MK", "MT", "MD", "MC", "ME", "NL", "PT","RO", "RU", "SM", "RS", "SK", "SI", "ES", "CH", "TR", "UA", "VA","SE","DK"],
    currencies: ["EUR"]
  },
  {
    countries: ["JP"],
    currencies: ["USD"]
  },
  {
    countries: ["NO"],
    currencies: ["NOK"]
  },
  {
    countries: ["KR"],
    currencies: ["KRW"]
  },
  {
    countries: ["CA"],
    currencies: ["CAD"]
  },
  {
    countries: ["NZ"],
    currencies: ["NZD"]
  },
  {
    countries: ["KR"],
    currencies: ["KRW"]
  },
  {
    countries: ["IN"],
    currencies: ["INR"]
  },
  {
    countries: ["PL"],
    currencies: ["PLN"]
  },
  {
    countries: ["BR"],
    currencies: ["BRL"]
  },
  {
    countries: ["ZA"],
    currencies: ["ZAR"]
  },{
    countries: ["HU"],
    currencies: ["HUF"]
  },
];

export const restOfTheWorldCurrencies=["USD"];


/* Games User Dashboard Currency Limits to show the corresponding banners */
export const userCashLimitCheck = [
  {
  currencyCode: "EUR",
  currencyLimit : 10
  },
  {
    currencyCode: "USD",
    currencyLimit : 10
  },
  {
    currencyCode: "CAD",
    currencyLimit : 10
  },
  {
    currencyCode: "NZD",
    currencyLimit : 10
  },
  {
      currencyCode: "GBP",
      currencyLimit : 10
  },
  {
    currencyCode: "NOK",
    currencyLimit : 100
  },
  {
    currencyCode: "SEK",
    currencyLimit : 100
  },
  {
    currencyCode: "DKK",
    currencyLimit : 100
 } 
]

export let language = {
  'en': 'en_US',
  'fi': 'fi_FI',
  'sv': 'sv_SE',
  'no': 'no_NO',
  'de': 'de_DE',
  'ja': 'ja_JP',
  'nz': 'en_NZ',
  'cd': 'en_CA',
  'fr': 'fr_CA',
  'ko': 'ko_KR',
  'pl': 'pl_PL',
  'in': 'en_IN',
  'et': 'et_EE',
  'hu': 'hu_HU'
  }

//export const restrictedCountries = ["AF","AO","AU","BG","EE","FR","GG","HK","HU","IR","IL","LB","KP","PH","RU","SG","SY","TW","TR","UA","YE","US"];


// export const initialRestrictedCountries = ["AF", "AS", "AO", "AU", "IO", "BG", "CZ", "DK", "EE", "FR", "PF", "GI", "GR", "GL", "GU", "GG", "HK", "IR", "IM", "IL", "IT", "JE", "LB", "MS", "MP", "PH", "PT", "PR", "RO", "SG", "ES", "SY", "TR", "GB", "UM", "US", "YE", "DZ", "AG", "AR", "BE", "BV", "BR", "BF", "BI", "KH", "CM", "CF", "TD", "CN", "CG", "CI", "CU", "CW", "CY", "EG", "ER", "ET", "FK", "GF", "TF", "GM", "GP", "GN", "GW", "HT", "IQ", "KZ", "KP", "KW", "LA", "LS", "LR", "LY","LV", "MG", "ML", "MH", "MQ", "MZ", "MM", "NP", "AN", "NE", "NG", "PK", "PS", "PA", "PL", "SL", "SK", "SI", "SO", "ZA", "GS", "TJ", "TZ", "TT", "TN", "UG", "UY", "VU", "VG", "VI", "ZM", "ZW", "IE","SE"];
/**adding trustlyCountries to initial restricted countries so users wont have access to trustlyCountries in the country dropdown during registration */
// export const restrictedCountries = initialRestrictedCountries.concat(environment.trustlyCountries);

export const gameProviderName: Map<string, string> = new Map<string, string>();
gameProviderName.set("Betsoft", "Betsoft");
gameProviderName.set("NYX", "NYX");
gameProviderName.set("Microgaming", "Microgaming");
gameProviderName.set("ELK", "ELK Studios");
gameProviderName.set("Pragmatic Play", "Pragmatic Play");
gameProviderName.set("Play N Go", "Play'n GO");
gameProviderName.set("Quick Spin", "Quickspin");
gameProviderName.set("pg", "Push Gaming");
gameProviderName.set("iSoftBet", "iSoftBet");
gameProviderName.set("thunderkick", "Thunderkick");
gameProviderName.set("Relax", "Relax");
gameProviderName.set("onextwo", "1X2 Gaming");
gameProviderName.set("greentube", "Greentube");

export const bonusDescMap: Map<string, string> = new Map<string, string>();
bonusDescMap.set("happy", "bonusValue.Happy" );
bonusDescMap.set("bonus2", "bonusValue.bonus2" );
bonusDescMap.set("bonus3", "bonusValue.bonus3" );
bonusDescMap.set("bonus4", "bonusValue.bonus4" );
bonusDescMap.set("bonus5", "bonusValue.bonus5" );

export const idealBankNameMethods = ['ABN_AMRO', 'Rabobank', 'ING', 'Triodos_Bank', "ASN_Bank", "SNS_Bank", "SNS_Regio_Bank","Van_Lanschot_Bankiers","BUNQ_Bank","Knab_Bank","MONEYOU"];
export const idealBankName: Map<string, string> = new Map<string, string>();
idealBankName.set("ABN_AMRO", "ABN Amro");
idealBankName.set("Rabobank", "Rabobank");
idealBankName.set("ING", "ING");
idealBankName.set("Triodos_Bank", "Triodos Bank");
idealBankName.set("ASN_Bank", "ASN Bank");
idealBankName.set("SNS_Bank", "SNS Bank");
idealBankName.set("SNS_Regio_Bank", "SNS Regio Bank");
idealBankName.set("Van_Lanschot_Bankiers", "F. van Lanschot Bankiers");
idealBankName.set("BUNQ_Bank", "BUNQ");
idealBankName.set("Knab_Bank", "Knab Bank");
idealBankName.set("MONEYOU", "Moneyou");

// export let countryLanguage = {
//   'SE': 'en',
//   'AX': 'sv',
//   'NO': 'no',
//   'FI': 'fi',
//   'DE': 'de',
//   'NZ': 'nz',
//   'CA': 'cd',
//   'JP': 'ja',
//   'AT': 'de',
//   'IN': 'en',
//   'KR': 'ko'
// }
/*Add the languages for internationalisation*/
// export const languageCodes = ['en', 'fi', 'no', 'cd', 'nz', 'ja', 'de', 'fr', 'ko'];

export let PNPCountry = environment.trustlyCountries;
export let timerBannerRunningTime = 1260; 
export enum bannerState {
  BANNED = "BANNED",
  EXPIRED = "EXPIRED",
  MINIMISED = "MINIMISED",
  SLEEP = "SLEEP",
  RUNNING = "RUNNING",
  SHOWING = "SHOWING"
}
/*Adding the errorCodes which comes on Login API call: For issue site is down for maintainance...." */
export const loginErrorCodes = ["11002", "11003", "100152"];

export const browsertoSupportedLanguageMappingList = {
  "nb": "no",
  "nb-no": "no",
  "nb-NO": "no",
  "nn": "no",
  "nn-no": "no",
  "nn-NO": "no",
  "en-CA": "cd",
  "en-ca": "cd",
  "fr": "fr",
  "fr-CA": "fr",
  "fr-ca": "fr",
  "fr-FR": "fr",
  "fr-fr": "fr",
  "en-NZ": "nz",
  "de-DE": "de",
  "de-CH": "de",
  "de-AT": "de",
  "de-LI": "de",
  "en-GB": "en",
  "en-IN": "in",
  "en-in": "in",
  "en-US": "en",
  "fi-FI": "fi",
  "ja-JP": "ja",
  "ko-KR": "ko",
  "et":"et",
  "et-EE":"et",
  "et-ee":"et"
}

export enum sortState {
  asc = "asc",
  desc = "desc",
  none = "none"

 } 
 export const userMinimumLifeTimeTransactionSummaryRequiredForKyc = {
  "requestedWithdrawalAmountinInhouseCurrency": 2000,
  "successfulDepositAmountInhouseCurrency": 2000
 }

 export const incomeSourceList = [
  {"value":"savingsFromSalary","name":'sourceoffundscheckboxnames.savingsfromsalary'},
  {"value":"companyProfits","name":'sourceoffundscheckboxnames.companyprofits'},
  {"value":"salesOfSharesOrOtherInvestments","name":'sourceoffundscheckboxnames.salesofsharesorotherinvestments'},
  {"value":"saleOfProperty","name":'sourceoffundscheckboxnames.saleofproperty'},
  {"value":"companySale","name":'sourceoffundscheckboxnames.companysale'},
  {"value":"dividentPayment","name":'sourceoffundscheckboxnames.dividentpayment'},
  {"value":"fixedDepositSavings","name":'sourceoffundscheckboxnames.fixeddepositsavings'},
  {"value":"inheritance","name":'sourceoffundscheckboxnames.inheritance'},
  {"value":"loan","name":'sourceoffundscheckboxnames.loan'},
  {"value":"gift","name":'sourceoffundscheckboxnames.gift'},
  {"value":"other","name":'sourceoffundscheckboxnames.other'}
 ];

export const APIACCOUNTVERIFICATION = {
  VERIFIED: "vrfn_verified",
  INITIATED: "vrfn_init",
  NEW: "vrfn_new",
  FAILED:"vrfn_failed" 
}
export const APPACCOUNTVERIFICATION = {
  VERIFIED: "verified",
  INITIATED: "initiated",
  NEW: "new",
  ADDRESSSTATUS_PENDING: "addressStatusPending",
  IDENTITYSTATUS_PENDING: "identityStatusPending",
  SOURCEOFINCOMESTATUS_PENDING:"sourceOfIncomeStatusPending",
  NOTVERIFIED:"notVerified"
}

export const ALL_GAMES_LIMIT = 18;

export const EXCLUDE_TAGS = ["exclusive","featured","new", "minislot", "promotion", "jackpot", "hot", "hidden", "footer"];

export const myAccountTabs = [
  {name: 'profileSettingsComp.myAccount', path: '/myaccount'},
  {name: 'profileSettingsComp.cashier', path: '/myaccount/cashier'},
  {name: 'profileSettingsComp.bonuses', path: '/myaccount/bonuses'},
  {name: 'profileSettingsComp.withdrawals', path: '/myaccount?pendingCashout=true',id:'withdrawls',hide:true,activeIcon:'withdraw-active.png',inactiveIcon:'withdraw-inactive.png',altText:'Withdrawls'},
  {name: 'profileSettingsComp.myTransactions', path: '/myaccount/transactions'},
  {name: 'profileSettingsComp.gameHistory', path: '/myaccount/bethistory'}
];

export const myAccountTabsMobile = [
  {name: 'profileSettingsComp.account', path: '',id:'myaccount',hide:false,activeIcon:'myaccount-active.png',inactiveIcon:'myaccount-inactive.png',altText:'My Account'},
  {name: 'profileSettingsComp.bonuses', path: '',id:'activebonuses',hide:false,activeIcon:'bonuses-active.png',inactiveIcon:'bonuses-inactive.png',altText:'Active Bonuses'},
  {name: 'profileSettingsComp.withdrawals', path: '/myaccount?pendingCashout=true',id:'withdrawls',hide:true,activeIcon:'withdraw-active.png',inactiveIcon:'withdraw-inactive.png',altText:'Withdrawls'},
  {name: 'profileSettingsComp.myTransactions', path: '',id:'transactions',hide:false,activeIcon:'transactions-active.png',inactiveIcon:'transactions-inactive.png',altText:'Transactions'},
  {name: 'profileSettingsComp.gameHistory', path: '',id:'gamehistory',hide:false,activeIcon:'gamehistory-active.png',inactiveIcon:'gamehistory-inactive.png',altText:'Game History'}
];


export const mapClosedAccountErrorCodes = {
  100435: "closureEddMissing", 
  100436: "closureLinkedAccount", 
  100437: "closureNoReasonCustomerReq", 
  100438: "closureChargebackSoreLoser", 
  100439: "closureChargebackFraud", 
  100440: "closureFraud", 
  100441: "closureAml",
  100443: "closureBonusAbuse", 
  100444: "closureProblemGambling", 
  100445: "closureSpendingTooMuch", 
  100446: "closureOperatorExclusion", 
  100448: "closureUnderAge", 
  100449: "closureLinkedInSamePartner", 
  100450: "closureSimilarPlayer", 
  100451: "closureInactive", 
  100452: "closureSimilarPlayerFraud", 
  100453: "closureRiskCheckFailure"
}

export enum txnState {
  SUCCESS_MESSAGE = "successful",
  FAILURE_MESSAGE = "failure"
}


export const swiperGridMobileConfig:SwiperOptions = {
  slidesPerView: 2.10,
  slidesPerGroup: 2,
  spaceBetween: 12,
}
export const swiperGrid2Config:SwiperOptions = {
  slidesPerView: 6,
  slidesPerGroup: 6,
  freeMode: false,
  observer: true,
  observeParents: false,
  navigation: true,
  spaceBetween: 18,
  breakpoints: {
    '1024': {
      direction: 'horizontal',
      slidesPerView: 6,
      slidesPerGroup: 6,
      spaceBetween: 18,
    },
    '767': {
      direction: 'horizontal',
      slidesPerView: 2.05,
      slidesPerGroup: 2,
      spaceBetween: 12,
    },
    '480': {
      direction: 'horizontal',
      slidesPerView: 2.05,
      slidesPerGroup: 2,
      spaceBetween: 12,
    },
    '0': {
      direction: 'horizontal',
      slidesPerView: 2.05,
      slidesPerGroup: 2,
      spaceBetween: 12,
    }
    
  }
};

export const swiperGrid3Config:SwiperOptions = {
  slidesPerView: 3,
  slidesPerGroup: 3,
  spaceBetween: 18,
  freeMode: false,
  observer: true,
  observeParents: false,
  navigation: true,
  breakpoints: {
    '767': {
      slidesPerView: 2.05,
      slidesPerGroup: 2,
      spaceBetween: 12
    },
    '480': {
      slidesPerView: 1.5,
      slidesPerGroup: 1,
      spaceBetween: 12
    }
  }
};

export const swiperGridAutoConfig:SwiperOptions = {
  slidesPerView: 8,
  slidesPerGroup: 8,
  spaceBetween: 10,
  freeMode: false,
  observer: true,
  observeParents: false,
  navigation: true,
  breakpoints: {
    '1024': {
      slidesPerView: 6,
      slidesPerGroup: 6
    },
    '767': {
      slidesPerView: 'auto',
      freeMode: true,
      observer: true,
      observeParents: false
    }
  }
};

export const swiperGrid4Config:SwiperOptions = {
  slidesPerView: 'auto',
  slidesPerGroup: 1,
  spaceBetween: 20,
  grabCursor: true,
  freeMode: false,
  observer: true,
  observeParents: false,
  breakpoints: {
    '767': {
      slidesPerView: 2.05,
      slidesPerGroup: 2,
      spaceBetween: 12
    },
    '480': {
      slidesPerView: 1.5,
      slidesPerGroup: 1,
      spaceBetween: 12
    }
  }
};

export const swiperPaginationConfig:SwiperOptions = {
  slidesPerView: 1.091,
  slidesPerGroup: 1,
  spaceBetween: 10,
  pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  }

  export const swiperSeoConfig:SwiperOptions = {
    slidesPerView: 1.10,
    slidesPerGroup: 1,
    spaceBetween: 12,
    grabCursor: false,
    // loopedSlides: 1.10,
    // loop: true,
    centeredSlides:true,
    direction: 'horizontal',
    breakpoints: {
      '992':{
        slidesPerView: 1.25,
        spaceBetween: 20
      }
    }
}
export const policiesTypes={
  'TERMS_AND_CONDITIONS':{
    type: 'TERMS_AND_CONDITIONS',
    label:'footerComp.termsConditions',
    url:'terms-and-conditions'
  }
}
export const xSaleInfoForBuumi = {
  'encoded':'https://record.njordaffiliates.com/_xLZwNh_cTFTGs5YK48Vb6WNd7ZgqdRLk/1/',
  'siteNameWithAffId':'https://www.buumi.com/en?affid='
}
export const statesAvailableCountrys = [
  {
    countryIso:'CA',
    countryName:'Canada',
    countryStates:[
      {name:"Nunavut", code:'NU'},
      {name:"Québec", code:'QUÉBEC'},
      {name:"Northwest Territories", code:'NT'},
      {name:"British Columbia", code:'BC'},
      {name:"Alberta", code:'AB'},
      {name:"Saskatchewan", code:'SK'},
      {name:"Manitoba", code:'MB'},
      {name:"Yukon", code:'YUKON'},
      {name:"Newfoundland and Labrador", code:'NL'},
      {name:"New Brunswick", code:'NB'},
      {name:"Nova Scotia", code:'NS'},
      {name:"Prince Edward Island", code:'PE'},
      {name:"Ontario", code:'ON'}
    ],
    defaultState:"NU",
    isEnabled:true
  }
]


export const userJurisdictions = ['estonia', 'curacao']

// changes for fi and et language payment logos
export const pnpLanguagePaymentlogos = ['fi', 'et']

export const coolOffJurisdictions = ['curacao', 'anjouan'];
